
export const SLIDE_IN_MODAL_DELAY_IN_SECONDS = 30000;